import React from "react";
import { BreadCrump } from "../BreadCramp/BreadCrump";
import { SingleNftInfo } from "./SinfleNftInfo/SinfleNftInfo";
import { SingleNftTable } from "./SinfleNftTable/SinfleNftTable";
import { SingleNftMain, SingleNftMainImg, SingleNftMainRight, SingleNftWrapper } from "./SingleNft.styled";

export const SingleNft = () => {
  return (
    <SingleNftWrapper>
      <div className='container'>
        <BreadCrump />
        <SingleNftMain>
          <SingleNftMainImg>
            <img src='../../../assets/img/default/nft/1.jpg' lt='nft' />
          </SingleNftMainImg>
          <SingleNftMainRight>
            <SingleNftInfo />
            <SingleNftTable />
          </SingleNftMainRight>
        </SingleNftMain>
      </div>
    </SingleNftWrapper>
  );
};
